<!-- 商品详情 -->
<template>
  <div class="page">
    <Nuxt />
    <Lfooter />
  </div>
</template>

<script>
import Lfooter from '@/components/Lfooter/index.vue'
export default {
  name: 'detailsPage',
  components: {
    Lfooter
  },
  scrollToTop: true,
  data() {
    return {}
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.page {
  height: 100%;
  position: relative;
}
</style>
